import React, { useState } from "react";
import { IntlProvider } from "react-intl";
import { Helmet } from "react-helmet";
import { AuthProvider } from "./providers/Auth";
import { FeedbackProvider } from "./providers/Feedback";
import { APIProvider } from "./providers/API";
import { OrdersProvider } from "./providers/Orders";
import { WidgetSimulatorProvider } from "./providers/WidgetSimulator";
import { ShopperCartProvider } from "./providers/ShopperCart";
import { StyleProvider } from "./providers/Style";
import Router from "./providers/Router";
import getMessagesForLocale from "./locales/index";
import { supportedLocales } from "./utils";

const App = () => {
  const [locale, setLocale] = useState(supportedLocales.es);
  const handleChangeLocale = (merchantLocale) => {
    const newLocale = merchantLocale;
    setLocale(newLocale);
  };

  window.locale = locale;
  const messages = getMessagesForLocale(locale);

  return (
    <>
      <Helmet>
        {locale && <html lang={locale.split("-")[0]} translate="no" />}
      </Helmet>
      <IntlProvider locale={locale} defaultLocale="es-ES" messages={messages}>
        <AuthProvider>
          <FeedbackProvider>
            <APIProvider>
              <StyleProvider>
                <OrdersProvider>
                  <WidgetSimulatorProvider>
                    <ShopperCartProvider
                      handleChangeLocale={handleChangeLocale}
                    >
                      <Router />
                    </ShopperCartProvider>
                  </WidgetSimulatorProvider>
                </OrdersProvider>
              </StyleProvider>
            </APIProvider>
          </FeedbackProvider>
        </AuthProvider>
      </IntlProvider>
    </>
  );
};

export default App;
